// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__e3JHL","img__con":"styles_img__con__wjhKf"};